import { createListenerMiddleware } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../../app/store";
import { hydrateUser } from "./userSlice";
import { showToast } from "../notifications/notificationsSlice";

export const userListenerMiddleware = createListenerMiddleware();

const startAppListening = userListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startAppListening({
    actionCreator: hydrateUser.rejected,
    effect: async (_action, listenerApi) => {
        listenerApi.dispatch(
            showToast({
                message: "Couldn't restore user data.",
                severity: "error",
            }),
        );
    },
});
